import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const WA = process.env.REACT_APP_WHATSAPP_NUMBER;

export const WhatsAppFloat = () => (
  <motion.a
    data-testid="whatsapp-float-button"
    href={`https://wa.me/${WA}?text=${encodeURIComponent("Olá! Vim pelo site da leve essenza e quero saber mais sobre os suplementos.")}`}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 2.2, duration: 0.5, ease: [0.34, 1.56, 0.64, 1] }}
    whileHover={{ scale: 1.1 }}
    className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-military text-baby flex items-center justify-center shadow-xl"
    aria-label="Falar no WhatsApp"
  >
    <span className="absolute inset-0 rounded-full bg-baby animate-pulse-ring" />
    <MessageCircle size={24} className="relative z-10" />
  </motion.a>
);
